import { light } from "@mui/material/styles/createPalette";

const configUrlSetor = {
    SETOR_CREATE_SITE: '/site/admin/cadastro/setor/create',
    SETOR_EDIT_SITE: '/site/admin/cadastro/setor/edit/:id',
    SETOR_LIST_SITE: '/site/admin/cadastro/setor/list',
    SETOR_EDIT_LK_SITE: '/site/admin/cadastro/setor/edit/',
    SETOR_LOGO_SITE: '/site/admin/cadastro/setor/logo',

    SETOR_CREATE_SABER: '/saber/cadastro/setor/create',
    SETOR_EDIT_SABER: '/saber/cadastro/setor/edit/:id',
    SETOR_LIST_SABER: '/saber/cadastro/setor/list',
    SETOR_EDIT_LK_SABER: '/saber/cadastro/setor/edit/',
    SETOR_LOGO_SABER: '/saber/cadastro/setor/logo',

    SETOR_FILTER_BY_SEARCH_EP: '/api/saber/admin/setor', // não muda com layout
    SETOR_API_EP: '/api/saber/admin/setor' // não muda com layo
};

export default configUrlSetor;